"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamoPagination = void 0;
const React = __importStar(require("react"));
const material_1 = require("@mui/material");
const makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
const VerticalAlignTopRounded_1 = __importDefault(require("@mui/icons-material/VerticalAlignTopRounded"));
const KeyboardArrowLeftRounded_1 = __importDefault(require("@mui/icons-material/KeyboardArrowLeftRounded"));
const KeyboardArrowRightRounded_1 = __importDefault(require("@mui/icons-material/KeyboardArrowRightRounded"));
const PADDING_MULTIPLIER = 1.25;
const useStyles = makeStyles_1.default((theme) => ({
    root: {
        backgroundColor: theme.palette.black['600'],
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        justifyContent: 'normal',
        zIndex: 1250,
        height: '3.25rem',
    },
    goToTop: {
        lineHeight: '3.25rem',
    },
    gridItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minHeight: '3.25rem',
    },
    rowsPerPage: {
        marginRight: theme.spacing(3),
        marginLeft: theme.spacing(1),
        '& .MuiFilledInput-root': {
            minHeight: 'auto',
        },
        '& .MuiFilledInput-input': {
            padding: theme.spacing(PADDING_MULTIPLIER),
            paddingRight: theme.spacing(4),
            fontWeight: 600,
        },
    },
    iconButton: {
        padding: '0.5rem',
        margin: '0 0.25rem 0 0.25rem',
    },
}));
/**
 * Pagination that always sticks to the bottom of the screen
 * Page number always starts from 1
 * @param props - Pagination props
 * @returns JSX Element
 */
exports.DynamoPagination = (props) => {
    const { loading, disableNextButton, disablePrevButton, onNext, onPrev } = props;
    const classes = useStyles();
    // Scrolls to the top with smooth behaviour
    const goToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    return (React.createElement("div", { className: classes.root },
        React.createElement(material_1.Grid, { container: true, direction: "row", justifyContent: "space-between", alignItems: "center" },
            React.createElement(material_1.Grid, { item: true, className: classes.goToTop },
                React.createElement(material_1.Button, { size: "large", onClick: goToTop, startIcon: React.createElement(VerticalAlignTopRounded_1.default, null) }, "Top")),
            !loading ? (React.createElement(material_1.Grid, { item: true, className: classes.gridItem },
                React.createElement(material_1.Box, { display: "flex", justifyContent: "space-between", alignItems: "center" },
                    React.createElement(material_1.IconButton, { className: classes.iconButton, disabled: disablePrevButton, onClick: onPrev, size: "large" },
                        React.createElement(KeyboardArrowLeftRounded_1.default, null)),
                    React.createElement(material_1.IconButton, { className: classes.iconButton, disabled: disableNextButton, onClick: onNext, size: "large" },
                        React.createElement(KeyboardArrowRightRounded_1.default, null))))) : (React.createElement(React.Fragment, null)))));
};
//# sourceMappingURL=data:application/json;base64,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